import { Layout } from "@/components/layout/Layout";
import { BlogScanSEO } from "@/components/blog-scan/BlogScanSEO";
import { BlogScanHero } from "@/components/blog-scan/BlogScanHero";
import { BlogScanIntro } from "@/components/blog-scan/BlogScanIntro";
import { BlogScanSteps } from "@/components/blog-scan/BlogScanSteps";
import { BlogScanReturns } from "@/components/blog-scan/BlogScanReturns";
import { BlogScanWhichApp } from "@/components/blog-scan/BlogScanWhichApp";
import { BlogScanWhyRefound } from "@/components/blog-scan/BlogScanWhyRefound";
import { BlogScanTipsFAQ } from "@/components/blog-scan/BlogScanTipsFAQ";
import { RelatedArticles } from "@/components/blog/RelatedArticles";

const BlogScan = () => {
  return (
    <Layout>
      <BlogScanSEO />
      <BlogScanHero />
      <BlogScanIntro />
      <BlogScanSteps />
      <BlogScanReturns />
      <BlogScanWhichApp />
      <BlogScanWhyRefound />
      <BlogScanTipsFAQ />
      <RelatedArticles currentSlug="comment-numeriser-recus-application-mobile" />
    </Layout>
  );
};

export default BlogScan;
